<template>
  <div class="ranking-list-container" @click.stop="onHideClick">
    <div class="ranking-list" :style="{ 'max-height': maxHeight }">
      <p class="ranking-title" @click.stop="onHideClick">
        <i class="dd-iconfont icon-guanbianniu arrow-right"></i>
        {{ title }}
        <slot />
      </p>
      <template v-if="rankingList.length">
        <ranking-item
          v-for="(item, index) in rankingList"
          :key="index"
          :item="{ ...item, rank: index + 1 }"
        />
      </template>
    </div>
  </div>
</template>

<script>
import RankingItem from '@/components/pass-list-item.vue';

export default {
  name: 'PassList',
  components: {
    RankingItem,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    role: {
      type: String,
      default: 'student',
    },
    rankingList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      maxHeight: '124px',
      accountId: '',
      user: {},
    };
  },
  computed: {
    // 当前用户是否在排名中
    isIncluded() {
      return (
        this.rankingList.filter(
          (v) => v.account_id === this.currentUser.account_id,
        ).length > 0
      );
    },
    sortedByRate() {
      if (!this.rankingList.length) {
        return [];
      }
      return [...this.rankingList].sort((a, b) => a.right_rate - b.right_rate);
    },
    sortedByTime() {
      if (!this.rankingList.length) {
        return [];
      }
      return [...this.rankingList].sort((a, b) => b.end_time - a.end_time);
    },
    currentUser() {
      const users = this.rankingList.filter(
        // eslint-disable-next-line eqeqeq
        (v) => v.account_id == this.accountId,
      );
      return {
        real_name: this.user.realName,
        finish_topic_count: 0,
        ...users[0],
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.maxHeight = '80%';
    });
    const user = JSON.parse(localStorage.getItem('UserInfo')) || {};
    let { accountId } = this.$route.query;
    if (!accountId) {
      accountId = user.accountId;
    }
    this.accountId = accountId;
    this.user = user;
  },
  methods: {
    onHideClick() {
      this.maxHeight = '124px';
      setTimeout(() => {
        this.$emit('click');
      }, 300);
    },
    isFastest(item) {
      if (!item || !this.rankingList.length) {
        return false;
      }
      return (
        item.end_time
        === this.sortedByTime[this.sortedByTime.length - 1].end_time
      );
    },
    isCorrectest(item) {
      if (!item || !this.rankingList.length) {
        return false;
      }
      return (
        item.right_rate
        === this.sortedByRate[this.sortedByRate.length - 1].right_rate
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.ranking-list-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;

  .no-border {
    >>> .ranking-info {
      border-bottom: 0;
    }
  }
  .ranking-list {
    background-color: #fff;
    border-radius: 24px 24px 0px 0px;
    position: absolute;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    max-height: 124px;
    overflow-y: auto;
    transition: all 0.3s;
    .list-count {
        color: rgba(17,31,44,0.5);
        font-size: 28px;
    }
  }
  .ranking-title {
    color: #111f2c;
    font-size: 34px;
    line-height: 48px;
    padding: 24px;
    text-align: center;
    // prettier-ignore
    border-bottom: 1PX solid rgba(17, 31, 44, 0.12);
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 2;
  }
  .arrow-right {
    font-size: 25px;
    color: #a0a5ab;
    position: absolute;
    right: 36px;
    // top: 33px;
  }
  .empty-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 846px;
    flex-direction: column;
    p {
      color: #191f25;
      font-size: 30px;
      opacity: 0.56;
    }
    img {
      width: 200px;
      height: 200px;
      margin-bottom: 32px;
    }
  }
  .rank-bar {
    width: 100%;
    height: 16px;
    background: rgba(25, 31, 37, 0.08);
  }
}
</style>
